var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPencilNew(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.6499 16V16.5H2.1499H3.3999H3.60701L3.75346 16.3535L13.0035 7.1035L13.3535 6.7535L13.007 6.39999L11.782 5.14999L11.4285 4.78926L11.0713 5.1464L1.79635 14.4214L1.6499 14.5678V14.775V16ZM15.8486 4.94416L13.1867 2.30202L14.1501 1.35686L14.1501 1.35687L14.1535 1.3535C14.3368 1.17015 14.5611 1.07495 14.8629 1.07495C15.1638 1.07495 15.3878 1.16999 15.5713 1.3535L16.7909 2.57309C16.9894 2.7852 17.0887 3.02343 17.1003 3.30736C17.111 3.56999 17.0275 3.77643 16.8316 3.96144L16.8264 3.96635L16.8213 3.9714L15.8486 4.94416ZM1.1789 14.3442L1.17892 14.3442L1.18024 14.3407C1.19166 14.3107 1.2178 14.2642 1.27846 14.2035L11.3999 4.08206L14.0678 6.74995L3.94635 16.8714L4.2999 17.225L3.94635 16.8714C3.88578 16.932 3.83894 16.9591 3.80812 16.9714C3.75709 16.9905 3.70532 17 3.6499 17H1.5499C1.43071 17 1.34609 16.964 1.26646 16.8844L0.912902 17.238L1.26646 16.8844C1.18576 16.8037 1.1499 16.7186 1.1499 16.6V14.5C1.1499 14.4448 1.15953 14.394 1.1789 14.3442Z",
    fill: "#707683",
    stroke: "#038E83"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencilNew);
export default __webpack_public_path__ + "static/media/pencil-new.0b3702ff.svg";
export { ForwardRef as ReactComponent };